/**
 * Cart drawer wristband upsell ("Claim Offer").
 *
 * Adds the real, existing "Daily Reminder Wristbands" product (2 FOR $2
 * variant) via the standard Ajax Cart API. No new product, bundle,
 * variant, or discount is involved - this only calls /cart/add.js with
 * the existing variant id and lets the theme's own cart-drawer refresh
 * (on:cart:change -> CartForm.refresh() -> theme.mergeNodes) take over,
 * exactly like every other add-to-cart button on this site. That means
 * Shopify's standard Add to Cart analytics event fires normally here -
 * this file does not fire any pixel events itself, so it cannot create
 * a duplicate AddToCart.
 *
 * Delegated on `document` (not bound to a specific button element)
 * because the card's markup is replaced wholesale by the theme's
 * data-merge system every time the cart refreshes - a direct listener
 * would be destroyed along with the old button on every refresh.
 */
(function () {
  var busy = false;

  theme.addDelegateEventListener(document, 'click', '[data-wristband-claim]', (evt, btn) => {
    if (busy) return;
    busy = true;

    var card = btn.closest('[data-wristband-upsell]');
    var message = card ? card.querySelector('[data-wristband-message]') : null;
    var label = btn.querySelector('.wristband-upsell__cta-label');
    var originalLabel = label.textContent;

    btn.disabled = true;
    label.textContent = 'Adding...';
    if (message) message.hidden = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }]
      })
    })
      .then((res) => {
        if (!res.ok) {
          return res.json().then((data) => {
            throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
          });
        }
        return res.json();
      })
      .then(() => {
        busy = false;
        // Same event every other add-to-cart control on this theme
        // dispatches - triggers the existing AJAX drawer refresh, which
        // will re-render this card away and show the wristbands as a
        // normal cart line item.
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));

        // Official Shopify custom-analytics hook (window.Shopify.analytics.publish),
        // not a bespoke event system - inert unless a pixel subscribes to it.
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('yv_cart_wristband_upsell_added', {
            productId: btn.dataset.productId,
            variantId: btn.dataset.variantId,
            price: 2.00,
            quantity: 1,
            location: 'cart_drawer'
          });
        }
      })
      .catch((err) => {
        busy = false;
        btn.disabled = false;
        label.textContent = originalLabel;
        if (message) {
          message.textContent = err.message || 'Something went wrong. Please try again.';
          message.hidden = false;
        }
      });
  });
})();
